define("shared/modifiers/scroll-phone-country", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  /**
   * ScrollPhoneCountryModifier scrolls the selected country into view when the
   * intl-tel-input dropdown opens and adds a search box to filter countries.
   *
   * Usage:
   * <PhoneInput {{scroll-phone-country}} />
   */
  class ScrollPhoneCountryModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "observer", undefined);
      _defineProperty(this, "containerWatcher", undefined);
      _defineProperty(this, "phoneInputElement", undefined);
      _defineProperty(this, "pollIntervalId", undefined);
      _defineProperty(this, "isSetup", false);
      _defineProperty(this, "selectedFlagButton", undefined);
      _defineProperty(this, "boundHandleClick", undefined);
      _defineProperty(this, "searchInput", undefined);
      _defineProperty(this, "countryList", undefined);
      _defineProperty(this, "allCountries", []);
    }
    modify(element) {
      this.phoneInputElement = element;

      // Find the intl-tel-input container (parent of the input)
      const itiContainer = element.closest('.iti');
      if (!itiContainer) {
        this.waitForItiContainer(element);
        return;
      }
      this.setupDropdownObserver(itiContainer);
    }
    waitForItiContainer(element) {
      // Watch for the parent node to get the .iti wrapper added
      const checkForContainer = () => {
        if (this.isSetup) {
          return;
        }
        const itiContainer = element.closest('.iti');
        if (itiContainer) {
          // Clean up watchers immediately
          if (this.pollIntervalId) {
            clearInterval(this.pollIntervalId);
            this.pollIntervalId = undefined;
          }
          if (this.containerWatcher) {
            this.containerWatcher.disconnect();
            this.containerWatcher = undefined;
          }
          this.setupDropdownObserver(itiContainer);
        }
      };

      // Check immediately and set up periodic checks
      this.pollIntervalId = window.setInterval(checkForContainer, 50);

      // Stop checking after 5 seconds
      setTimeout(() => {
        if (this.pollIntervalId) {
          clearInterval(this.pollIntervalId);
          this.pollIntervalId = undefined;
        }
      }, 5000);
      if (element.parentElement) {
        this.containerWatcher = new MutationObserver(() => {
          checkForContainer();
        });
        this.containerWatcher.observe(element.parentElement, {
          childList: true,
          subtree: false,
          attributes: false
        });
      }
    }
    setupDropdownObserver(itiContainer) {
      if (this.isSetup) {
        return;
      }
      this.isSetup = true;
      this.selectedFlagButton = itiContainer.querySelector('.iti__selected-flag') ?? undefined;
      if (this.selectedFlagButton) {
        this.boundHandleClick = () => {
          setTimeout(() => {
            this.addSearchBoxIfNeeded(itiContainer);
            this.scrollToSelectedCountry(itiContainer);
          }, 50);
        };
        this.selectedFlagButton.addEventListener('click', this.boundHandleClick);
      }
      this.observer = new MutationObserver(() => {
        this.handleDropdownStateChange(itiContainer);
      });
      this.observer.observe(itiContainer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    handleDropdownStateChange(container) {
      const isOpen = container.classList.contains('iti--open');
      if (isOpen) {
        setTimeout(() => {
          this.addSearchBoxIfNeeded(container);
          this.scrollToSelectedCountry(container);
        }, 10);
      }
    }
    scrollToSelectedCountry(container) {
      // Find the dropdown list
      const countryList = container.querySelector('.iti__country-list');
      if (!countryList) {
        return;
      }

      // Find the highlighted/active country
      const highlightedCountry = countryList.querySelector('.iti__highlight');
      const activeCountry = countryList.querySelector('.iti__active');
      const selectedCountry = highlightedCountry || activeCountry;
      if (selectedCountry) {
        selectedCountry.scrollIntoView({
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
    addSearchBoxIfNeeded(container) {
      const dropdownContent = container.querySelector('.iti__dropdown-content');
      const countryList = container.querySelector('.iti__country-list');
      if (!dropdownContent || !countryList || dropdownContent.querySelector('.iti__search-input')) {
        return; // Search box already exists
      }

      // Store reference to country list
      this.countryList = countryList;

      // Store all country items for filtering
      this.allCountries = Array.from(countryList.querySelectorAll('.iti__country'));

      // Create search input wrapper
      const searchWrapper = document.createElement('div');
      searchWrapper.className = 'iti__search-wrapper';

      // Create search input
      this.searchInput = document.createElement('input');
      this.searchInput.type = 'text';
      this.searchInput.className = 'iti__search-input';
      this.searchInput.placeholder = 'Search';
      this.searchInput.setAttribute('autocomplete', 'off');

      // Add input handler
      this.searchInput.addEventListener('input', () => this.filterCountries());

      // Prevent the dropdown from closing when clicking in the search box
      this.searchInput.addEventListener('click', e => e.stopPropagation());
      searchWrapper.appendChild(this.searchInput);

      // Insert search box at the top of the dropdown content (before the country list)
      dropdownContent.insertBefore(searchWrapper, countryList);

      // Focus the search input
      setTimeout(() => this.searchInput?.focus(), 10);
    }
    filterCountries() {
      if (!this.searchInput || !this.countryList) {
        return;
      }
      const searchTerm = this.searchInput.value.toLowerCase().trim();
      if (!searchTerm) {
        // Show all countries
        this.allCountries.forEach(country => {
          country.style.display = '';
        });
        return;
      }

      // Filter countries
      this.allCountries.forEach(country => {
        const countryName = country.querySelector('.iti__country-name')?.textContent?.toLowerCase() || '';
        const dialCode = country.querySelector('.iti__dial-code')?.textContent?.toLowerCase() || '';
        if (countryName.includes(searchTerm) || dialCode.includes(searchTerm)) {
          country.style.display = '';
        } else {
          country.style.display = 'none';
        }
      });
    }
    willRemove() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = undefined;
      }
      if (this.containerWatcher) {
        this.containerWatcher.disconnect();
        this.containerWatcher = undefined;
      }
      if (this.pollIntervalId) {
        clearInterval(this.pollIntervalId);
        this.pollIntervalId = undefined;
      }
      if (this.selectedFlagButton && this.boundHandleClick) {
        this.selectedFlagButton.removeEventListener('click', this.boundHandleClick);
        this.selectedFlagButton = undefined;
        this.boundHandleClick = undefined;
      }
      this.phoneInputElement = undefined;
      this.searchInput = undefined;
      this.countryList = undefined;
      this.allCountries = [];
      this.isSetup = false;
    }
  }
  _exports.default = ScrollPhoneCountryModifier;
});